<template>
  <Card>
    <el-row :gutter="10">
      <!--
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <div class="grid-content bg-purple">
          <span data-test="name" class="name-product">{{ product.name }}</span>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <div class="grid-content bg-purple-light" data-test="prod-quantity">
          <el-input-number v-model="stockJ"
          @change="inputQuantity"
          data-test="prod-stock-j"
          :min="0"></el-input-number>

          <span data-test="unit" class="unit-product">{{ product.unit }}{{ unitPluriel }}</span>
        </div>
      </el-col>
    -->
    <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6" class="container-prod-name">
      <div class="grid-content bg-purple prod-name">
        <span data-test="name" class="name-product">{{ product.name }}</span>
      </div>
    </el-col>
    <el-col :xs="24" :sm="24" :md="24" :lg="18" :xl="18" class="container-prod-quantities">
      <div class="grid-content bg-purple-light prod-quantities" data-test="prod-quantity">
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" class="input-line">
          <el-badge :value="'avant'" class="item" type="primary">
              <el-input-number v-model="stockJAv"
              @change="inputQuantityAv"
              data-test="prod-qty-av"
              size="small"
              :min="0"></el-input-number>
          </el-badge>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="input-line">
          <el-badge :value="'arrière'" class="item" type="primary">
            <el-input-number v-model="stockJAr"
            @change="inputQuantityAr"
            data-test="prod-qty-ar"
            size="small"
            :min="0"></el-input-number>
          </el-badge>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <!-- <el-badge value="Total" class="item" type="primary"> -->
          Total : <span data-test="stock-j">{{ stockJ }}</span>
        <!-- </el-badge> -->
          <span data-test="unit" class="unit-product">
            {{ product.unit }}{{ unitPluriel }}
          </span>
          <!-- <span data-test="unit" class="unit-product">
          {{ product.unit }}{{ unitPluriel }}</span> -->
        </el-col>

      </div>
    </el-col>
    </el-row>
  </Card>
</template>

<script>
import _ from 'lodash';
import Card from '@/components/Card/Card.vue';

export default {
  components: {
    // Inventory,
    Card,
  },
  props: {
    product: { type: Object },
    // productName: { type: String },
    // productQuantity: { type: Number, default: undefined },
  },
  data() {
    return {
      stockJ: null,
      stockJAv: null,
      stockJAr: null,
    };
  },
  mounted() {
    this.stockJ = this.product.stockJ;
    this.stockJAv = this.product.stockJAv;
    this.stockJAr = this.product.stockJAr;
    // this.reception = this.product.reception;
    // this.quantity = this.productQuantity;
  },
  methods: {
    inputQuantity() {
      console.log('input : ', this.stockJ);
      // const data = { ...this.product, stockJ: this.stockJ, reception: this.reception };
      const data = { ...this.product, stockJ: this.stockJ };
      console.log('value spread');
      console.log(data);
      this.$emit('onInput', data);
      // this.$emit('onInput');
    },
    inputQuantityAv() {
      const { stockJAv, stockJAr, ...productRest } = this.product;
      const checkDefault = (v, def) => (v == null ? def : v);
      const stockJAvCurrent = parseFloat(checkDefault(_.get(this, 'stockJAv', 0), 0));
      const stockJArCurrent = parseFloat(checkDefault(_.get(this, 'stockJAr', 0), 0));
      this.stockJ = stockJArCurrent + stockJAvCurrent;
      const data = {
        ...productRest,
        stockJAv: this.stockJAv,
        stockJ: this.stockJ,
      };
      this.$emit('onInput', data);
      // this.$emit('onInput');
    },
    inputQuantityAr() {
      const { stockJAv, stockJAr, ...productRest } = this.product;
      const checkDefault = (v, def) => (v == null ? def : v);
      const stockJAvCurrent = parseFloat(checkDefault(_.get(this, 'stockJAv', 0), 0));
      const stockJArCurrent = parseFloat(checkDefault(_.get(this, 'stockJAr', 0), 0));
      this.stockJ = stockJArCurrent + stockJAvCurrent;
      const data = {
        // ...this.product,
        ...productRest,
        stockJAr: this.stockJAr,
        stockJ: this.stockJ,
      };
      this.$emit('onInput', data);
      // this.$emit('onInput');
    },
  },
  computed: {
    unitPluriel() {
      return this.stockJ > 1 ? 's' : '';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
h3
  margin 40px 0 0

ul
  list-style-type none
  padding 0

li
  display inline-block
  margin 0 10px

a
  color #42b983

.name-product
  margin: 10px;
  display: inline-block;

.unit-product
  margin: 10px;

.container-product
  display: flex;
  flex-direction: row;

.container-prod-quantities, .container-prod-name {
  display: flex;
}

.prod-quantities, .prod-name
  width: 100%;

.el-badge__content.is-fixed
  top: -6px;
  right: 80px;
  z-index: 1000 !important;

/* .name-product
  width: 150px; */

.el-col
  border-radius: 4px;

.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
  text-align: right;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 40px;
  padding: 15px;
}
@media (max-width: 1199px){
  .bg-purple {
    text-align: left;
  }
  .input-line {
    margin-bottom: 18px;
  }
}

.el-badge__content
  z-index: 10;
</style>
